import React from 'react';
import Heading from '../../components/Heading';
import UploadIcon from "../../styles/svg/document-upload-icon.svg";
import DocumentUploadForm from './components/DocumentUploadForm';
import { Box } from '@mui/material';
import './documentUpload.scss';

function DocumentUpload() {
  const handleUploadSuccess = () => {
    // You can add any success handling here if needed
    console.log('Document upload successful');
  };

  return (
    <Box className="document-upload-container">
      <Heading title="Document Upload" icon={UploadIcon}/>
      <div>
        <DocumentUploadForm onUploadComplete={handleUploadSuccess} />
      </div>
    </Box>
  );
}

export default DocumentUpload;